import { handNode } from "./jd_handNode_component";
import { JdPokerComponent } from "./jd_poker_component";
import { Card } from "../../../../table/module/poker_table/poker_table_common";
import { PokerCommonColor } from "../../../../k9/module/table/component/poker_com_color";

//-----手牌效果
const {ccclass, property} = cc._decorator;

@ccclass
export class HandCardEffect extends cc.Component {

    @property(handNode)
    hands:handNode[] = [];

    //发牌
    playerDealCardsAnim(showCards:number,hands:cc.Node[],onFinish:Function = null){
        if (showCards == 3) {
            for (let index = 0; index < showCards-1; index++) {
                let hand = hands[index];
                let _fromTrans = this.getPosData(1,index);
                let targetPos = hand.parent.convertToNodeSpaceAR(_fromTrans.worldPos);
                this.scheduleOnce(()=>{
                    this.playNodeAnim(hand,targetPos,_fromTrans.scale,_fromTrans.angle,0.5,0,onFinish,cc.easeCubicActionOut());
                },0.05*index)
            }
        }
    }

        //发牌拓展动画
    jdPlayerDealCardsAnim(hands:JdPokerComponent[],moveNode:cc.Node,oldComp:JdPokerComponent[],isKqa:boolean){

            if (!isKqa) {
                if (moveNode == oldComp[oldComp.length-1].node) {//此时无需排序
                    return;
                }
            }
    
            let remoeNode = [];
            let isRemove = (node:cc.Node)=>{
                let move = false;
                for (let i = 0; i < remoeNode.length; i++) {
                    let noderem = remoeNode[i];
                    if (noderem == node) {
                        move = true;
                        break;
                    }
                }
                return move;
            }
    
            let doMoveCard = (handNode:cc.Node,_fromTrans:any)=>{
                handNode.stopAllActions();
                let targetPos = handNode.parent.convertToNodeSpaceAR(_fromTrans.worldPos); 
                let moveTo = cc.moveTo(0.2,cc.v2(handNode.x,handNode.y+100));
    
                let moveEnd = cc.callFunc(()=>{
                    handNode.zIndex = _fromTrans.zIndex-10;
                    this.playNodeAnim(handNode,targetPos,_fromTrans.scale,_fromTrans.angle,0.5,0,null,cc.easeCubicActionOut());
                })
                handNode.runAction(cc.sequence(moveTo,cc.delayTime(0.1),moveEnd));
            }
        
            for (let index = 0; index < hands.length; index++) {
                let hand = hands[index];
                for (let j = 0; j < oldComp.length; j++) {
                    let oldHand = oldComp[j];
                    if (!isRemove(oldHand.node)) {
                        if (oldHand.code == hand.code) {
                            let _fromTrans = this.getPosData(1,j);
                            let handNode = hand.node;
                            if (oldHand.node == handNode) {//移动节点
                                remoeNode.push(oldHand.node)
                                if (isKqa) {
                                    if (j != index) {
                                        doMoveCard(handNode,_fromTrans);//两张
                                        break;
                                    }
                                }else{
                                    if (oldHand.node == moveNode) {
                                        doMoveCard(handNode,_fromTrans);//两张
                                        break;
                                    }
                                }
                              
                            }
                            handNode.zIndex = _fromTrans.zIndex-10;
                            let targetPos = handNode.parent.convertToNodeSpaceAR(_fromTrans.worldPos);
                            this.scheduleOnce(()=>{
                                this.playNodeAnim(handNode,targetPos,_fromTrans.scale,_fromTrans.angle,0.5,0,null,cc.easeCubicActionOut());
                            },0.05*j)
                            break;
                        }
                    }
                }
            }
        }

    //发牌拓展动画
    playerDealCardsAnimEx(hands:PokerCommonColor[],moveNode:cc.Node,oldComp:PokerCommonColor[],isKqa:boolean){

        if (!isKqa) {
            if (moveNode == oldComp[oldComp.length-1].node) {//此时无需排序
                return;
            }
        }

        let remoeNode = [];
        let isRemove = (node:cc.Node)=>{
            let move = false;
            for (let i = 0; i < remoeNode.length; i++) {
                let noderem = remoeNode[i];
                if (noderem == node) {
                    move = true;
                    break;
                }
            }
            return move;
        }

        let doMoveCard = (handNode:cc.Node,_fromTrans:any)=>{
            handNode.stopAllActions();
            let targetPos = handNode.parent.convertToNodeSpaceAR(_fromTrans.worldPos); 
            let moveTo = cc.moveTo(0.2,cc.v2(handNode.x,handNode.y+100));

            let moveEnd = cc.callFunc(()=>{
                handNode.zIndex = _fromTrans.zIndex-10;
                this.playNodeAnim(handNode,targetPos,_fromTrans.scale,_fromTrans.angle,0.5,0,null,cc.easeCubicActionOut());
            })
            handNode.runAction(cc.sequence(moveTo,cc.delayTime(0.1),moveEnd));
        }
    
        for (let index = 0; index < hands.length; index++) {
            let hand = hands[index];
            for (let j = 0; j < oldComp.length; j++) {
                let oldHand = oldComp[j];
                if (!isRemove(oldHand.node)) {
                    if (oldHand.code == hand.code) {
                        let _fromTrans = this.getPosData(1,j);
                        let handNode = hand.node;
                        if (oldHand.node == handNode) {//移动节点
                            remoeNode.push(oldHand.node)
                            if (isKqa) {
                                if (j != index) {
                                    doMoveCard(handNode,_fromTrans);//两张
                                    break;
                                }
                            }else{
                                if (oldHand.node == moveNode) {
                                    doMoveCard(handNode,_fromTrans);//两张
                                    break;
                                }
                            }
                          
                        }
                        handNode.zIndex = _fromTrans.zIndex-10;
                        let targetPos = handNode.parent.convertToNodeSpaceAR(_fromTrans.worldPos);
                        this.scheduleOnce(()=>{
                            this.playNodeAnim(handNode,targetPos,_fromTrans.scale,_fromTrans.angle,0.5,0,null,cc.easeCubicActionOut());
                        },0.05*j)
                        break;
                    }
                }
            }
        }
    }

    //显示的张数，index 第几张
    private getPosData(showCount:number,index:number){
        return this.hands[showCount].transformDataList[index];
    }

    getTransform(showCount:number,index:number){
        let _showCount = showCount == 2 ? 0 : 1;
        let _fromTrans = this.getPosData(_showCount,index)
        return _fromTrans;
    }

    private playNodeAnim(node: cc.Node, targetPos: cc.Vec2, targetScale: number, targetAngle: number, duration: number, delay?: number, onFinish?: Function, easingType?){
        let self = this
        let do_fun = function(){
            let moveAnim = cc.moveTo(duration, targetPos)           
            let rotaAnim = cc.rotateTo(duration, targetAngle)
            let scaleAnim = cc.scaleTo(duration, targetScale)
            if(easingType){
                moveAnim = moveAnim.easing(easingType)
                rotaAnim = rotaAnim.easing(easingType)
                scaleAnim = scaleAnim.easing(easingType)
            }
            let tmpFun = function(){
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)   
            let swap = cc.spawn([moveAnim, rotaAnim, scaleAnim])
            var seq = cc.sequence([swap, callFun])
            node.stopAllActions()
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }



}
